module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.computedGoals.length > 0) ? _c('div', {
    attrs: {
      "id": "userGoals"
    }
  }, [_c('h5', [_vm._v(_vm._s(_vm.$t('message.labelMyGoals')))]), _vm._v(" "), _vm._l((_vm.computedGoals), function(goal, index) {
    return _c('div', {
      directives: [{
        name: "tooltip",
        rawName: "v-tooltip.bottom",
        value: (goal.goal),
        expression: "goal.goal",
        modifiers: {
          "bottom": true
        }
      }],
      key: ("goal-" + index),
      staticClass: "goal"
    }, [_c('img', {
      attrs: {
        "src": 'static/goals/' + goal.icon + '.png'
      }
    })])
  })], 2) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-22c2d452","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile/ProfileGoals/ProfileGoals.vue
// module id = 3084
// module chunks = 1